<template>
  <div class="modal fade" id="modalAlert" role="dialog">
    <div class="modal-dialog modal-dialog-35" v-bind:style="{'width': width}">
      <!-- Modal content-->
      <div v-bind:class="{'modal-success': dataAlert.isSuccess, 'modal-warning': dataAlert.isWarning, 'modal-error': dataAlert.isError}" class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <div v-if="dataAlert.isSuccess" class="success-content">
            <i class="fa fa-check" aria-hidden="true"></i>
          </div>
          <div v-if="dataAlert.isWarning" class="warning-content">
            <i class="fa fa-exclamation" aria-hidden="true"></i>
          </div>
          <div v-if="dataAlert.isError" class="error-content">
            <i class="fa fa-times" aria-hidden="true"></i>
          </div>
        </div>

        <div class="modal-body">
          <h4 class="certa title-text">{{objAlert.text}}</h4>
        </div>

        <div class="modal-footer offset-top-20">
          <button v-if="dataAlert.showBtnConfirm" v-on:click="confirmAlert()" type="submit" class="nunito btn-yellow-save">
            <span>{{dataAlert.btnMsg}}</span>
          </button>
          <button v-bind:class="{'btn-yellow-save': !dataAlert.showBtnConfirm, 'close-btn': dataAlert.showBtnConfirm}" v-on:click="closeModal()" class="nunito">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "success-register",
    props: ['objAlert'],
    watch: {
      objAlert: function (val) {
        this.dataAlert = val;

        if (val.width)
          this.width = val.width
      },
      emitValue : function(val){
        this.$emit('update:actionLeftMenu', val)
      }
    },
    data() {
      return {
        emitValue: {
          value: '',
          random: ''
        },
        width: '300px',
        dataAlert: {
          text: '',
          isSuccess: null,
          isWarning: null,
          isError: null,
          showBtnConfirm: false,
          btnMsg: '',
          emit: ''
        }
      }
    },
    methods: {
      confirmAlert() {
        this.emitValue = {value: this.dataAlert.emit, random: Math.floor(Math.random() * 500)};

        $('#modalAlert').modal('toggle');
        $('.modal-backdrop').remove();
      },
      closeModal() {
        $('#modalAlert').modal('toggle');
        $('.modal-backdrop').remove();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/vue/views/modals/modalAlert.vue